import { useState, useEffect } from 'react';
import globalState from '../utils/globalState';

export const useUserParams = () => {
  const [userParams, setUserParams] = useState(() => globalState.getAllUserParams());

  const getAllUserParams = () => {
    const params = globalState.getAllUserParams();
    if (JSON.stringify(params) !== JSON.stringify(userParams)) {
      setUserParams(params);
    }
    return params;
  };

  const getCurrentAgentName = () => {
    const params = getAllUserParams();
    return params.agentName;
  };

  const getCurrentAgentTitle = () => {
    const params = getAllUserParams();
    return params.agentTitle;
  };

  const getCurrentAgentNumber = () => {
    const params = getAllUserParams();
    return params.agentNumber;
  };

  const getCurrentAgentEmail = () => {
    const params = getAllUserParams();
    return params.agentEmail;
  };

  const getCurrentBrokerage = () => {
    const params = getAllUserParams();
    return params.brokerage;
  };

  const getCurrentQuote = () => {
    const params = getAllUserParams();
    return params.quote;
  };

  const getCurrentAbout = () => {
    const params = getAllUserParams();
    return params.about;
  };

  const getCurrentLogo = () => {
    const params = getAllUserParams();
    return params.logo;
  };

  const getCurrentHeadshot = () => {
    const params = getAllUserParams();
    return params.headshot;
  };

  useEffect(() => {
    const params = globalState.getAllUserParams();
    setUserParams(params);

    const unsubscribe = globalState.addListener(() => {
      const newParams = globalState.getAllUserParams();
      setUserParams(newParams);
    });

    return unsubscribe;
  }, []);

  return {
    getAllUserParams,
    getCurrentAgentName,
    getCurrentAgentTitle,
    getCurrentAgentNumber,
    getCurrentAgentEmail,
    getCurrentBrokerage,
    getCurrentQuote,
    getCurrentAbout,
    getCurrentLogo,
    getCurrentHeadshot
  };
};

export default useUserParams;

